import { createTheme } from '@mui/material/styles'
import { blue, indigo } from '@mui/material/colors'
import {
  CONTENT_COLUMN_MAX_WIDTH_VAR_CSS,
  contentColumnOverlaySx
} from './components/UI/contentColumn'

/**
 * Modal surfaces (Dialog, Drawer) render fixed to the viewport, so without this they spill
 * past the Anear header column on tablets and desktops. Capping the modal root also caps the
 * paper, whose widths are percentages of the root, and pinning the scrim to the root keeps
 * the dim confined to the column the way the burger menu already does.
 */
const contentColumnModalOverrides = {
  root: {
    ...contentColumnOverlaySx,
    '& > .MuiBackdrop-root': {
      position: 'absolute'
    }
  }
}

const DefaultTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      // Vibrant but readable blue on dark backgrounds (buttons, accents, links)
      main: blue[400],
      light: blue[200],
      dark: blue[700],
      contrastText: '#0B0F19'
    },
    secondary: {
      // Rich purple/teal accent for secondary CTAs and highlights
      main: indigo[300],
      light: indigo[100],
      dark: indigo[700],
      contrastText: '#0B0F19'
    },
    background: {
      default: '#020617',
      paper: '#0B1120'
    },
    text: {
      primary: '#E5E7EB',
      secondary: '#9CA3AF'
    }
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '6px'
        }
      }
    },
    MuiDialog: {
      styleOverrides: contentColumnModalOverrides
    },
    MuiDrawer: {
      styleOverrides: contentColumnModalOverrides
    },
    MuiPopover: {
      // Popovers/menus are positioned from viewport coordinates, so only the paper is capped.
      styleOverrides: {
        paper: {
          maxWidth: `min(calc(100% - 32px), ${CONTENT_COLUMN_MAX_WIDTH_VAR_CSS})`
        }
      }
    }
  }
})

export default DefaultTheme

